import { createContext } from "react";

export default createContext({
    getReport: () => {},
    fetching: false,
    stages: [],
    visits: []
});
